export default 'Collectivités — CEE & Décret Tertiaire | Solution Éco France';
